module.exports = __webpack_public_path__ + "static/img/1.e692500.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p6/1.png
// module id = dTgO
// module chunks = 1